export const adminPermission = ["admin"]


